/**
 * Landing - Unauthenticated marketing page
 *
 * Purpose: First impression at trueprice.art root
 * Shows: LandingHero with "Stop guessing. Start pricing." value prop
 * CTA: "Price Your Art — Free" → navigates to calculator
 */

import { useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import { LandingHero } from '@/components/brand';

export default function Landing() {
  const navigate = useNavigate();

  // SEO meta tags
  useEffect(() => {
    document.title = 'TruePrice — Know Your Floor. Own Your Price.';

    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute(
        'content',
        'The forensic pricing tool for painters. Calculate your true cost price in 60 seconds. Free, no signup required.'
      );
    }
  }, []);

  const handleGetStarted = () => {
    // Navigate to calculator — matches core promise:
    // "No signup required · 60 seconds to your first verdict"
    navigate('/app/calculate');
  };

  return <LandingHero onGetStarted={handleGetStarted} />;
}
